import { store } from 'app/shared/store/store';
import { ResponseError } from 'app/shared/models/response-error.error';
import { StoreKeys } from 'app/shared/constants/store-keys.enum';

export const globalErrorHandler = (): void => {
  window.addEventListener('error', ({ error }) => {
    if (error instanceof ResponseError) {
      store.set(StoreKeys.responseError, error);
    }
  });
};
